import React, { Component } from 'react'
import ListItem from 'containers/project-results/list-item'
import { checkStatus } from 'shared/helpers/checkStatus'
import { path } from 'ramda'
import { connect } from 'react-redux'
import { storage } from 'shared/helpers/user'

class ProjectResultsList extends Component {
  componentDidMount () {
    const userId = storage.getId()
    const userToken = storage.getToken()
    const authHeader = `${userId}:${userToken}`
    const timeSlotsForProjectUrl = this.props.forPreview
      ? `/v1/research/preview/project/${this.props.match.params.projectHash}`
      : `/v1/research/project/${this.props.match.params.projectId}`
    return fetch(timeSlotsForProjectUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'IC-Auth': authHeader,
      },
    })
      .then(checkStatus)
      .then(res => res.json())
      .then(res => {
        this.props.updateSelfServiceResults(res.timeSlots)
        this.props.updateState({
          [`project:${this.props.match.params.projectId}`]: {
            timeSlots: res.timeSlots,
            project: res.project,
            shareHash: res.shareHash,
          },
        })
      })
  }

  render () {
    const urlPath = path(['match', 'path'], this.props)
    const isSelfServiceResults = urlPath === '/projects/:projectId/results'
    const timeSlots = (isSelfServiceResults ? this.props.selfServiceResults : this.props.timeSlots) || []
    return (
      <div className={`list-container ${this.props.forPreview ? 'preview' : ''}`}>
        {timeSlots.map((timeSlot, i) => {
          const listItemUrl = this.props.forPreview
            ? `/preview/project/${this.props.match.params.projectHash}/interview/${timeSlot.shareHash}`
            : `/projects/${this.props.match.params.projectId}/results/interview/${timeSlot.timeSlotId}`
          return <ListItem {...timeSlot} listItemUrl={listItemUrl} key={i} />
        })}
      </div>
    )
  }
}

const mapState = state => ({ selfServiceResults: state.selfServiceResults })
const mapDispatch = {
  updateSelfServiceResults: payload => ({ type: 'FETCH_PROJECT_RESULTS_SUCCEEDED', payload }),
}

export default connect(mapState, mapDispatch)(ProjectResultsList)

